import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import React, { useState } from 'react';
import { StudentSideBarItemType } from '../../../component/side-bar-user/componenets/side-bar-student-item';
import { UserPageProfile } from '../pages/profile/user-page-profile';
import { SideBarLecturer } from '../../../component/side-bar-user/side-bar-lecturer';
import { UserPageLecturerLectures } from '../pages/lecturer/lectures/user-page-lecturer-lectures';
import { UserPageLecturerExams } from '../pages/lecturer/exams/user-page-lecturer-exams';
import { UserPageLecturerAssignments } from '../pages/lecturer/assignments/user-page-lecturer-assignments';
import { UserPageDocs } from '../pages/docs/user-page-docs';
import { UserPagePriceRate2 } from './lecturer-price-rate/user-page-price-rate2';
import { WorkingHours } from '../pages/lecturer/working-hours/working-hours';
import appApi from '../../../api/app-api';
import globalUserPage from '../../../stores/global-user-page';

interface UserPageLectureDatamodel {
  user: UserSummaryType;
}
export const UserPageLecture: React.FC<UserPageLectureDatamodel> = ({
  user,
}) => {
  const [itemSelectedType, setItemSelectedType] =
    useState<StudentSideBarItemType>(StudentSideBarItemType.PROFILE);

  const loadProfessorDetails = async () => {
    const updatedUserDetails = await appApi.getUserLecturerDetails(user.id);
    globalUserPage.lecturerDetails = updatedUserDetails.data.body;
  };

  const getElementItem = (itemType: StudentSideBarItemType) => {
    switch (itemType) {
      case StudentSideBarItemType.PROFILE:
        return <UserPageProfile user={user} />;
      /*case StudentSideBarItemType.COURSES:
        return <UserPageLecturerCourses />;*/
      case StudentSideBarItemType.LECTURES:
        return <UserPageLecturerLectures />;

      case StudentSideBarItemType.EXAMS:
        return <UserPageLecturerExams />;

      case StudentSideBarItemType.ASSIGNMENTS:
        return <UserPageLecturerAssignments />;
      case StudentSideBarItemType.RATES:
        return <UserPagePriceRate2 user={user} />;
      //return <UserPagePriceRates user={user} />;

      case StudentSideBarItemType.DOCS:
        return (
          <UserPageDocs user={user} loadUserDocuments={loadProfessorDetails} />
        );

      case StudentSideBarItemType.WORKING_HOURS:
        return <WorkingHours user={user} />;

      /*case StudentSideBarItemType.WORKING_HOURS:
          return <UserPageLecturerWorkingHours />;
        case StudentSideBarItemType.SALARIES:
          return <UserPagePriceRates user={user} />;*/
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        marginTop: '8px',
      }}
    >
      <SideBarLecturer
        onClick={(type) => {
          setItemSelectedType(type);
        }}
      />
      {getElementItem(itemSelectedType)}
    </div>
  );
};
